import { httpGet } from '../../../modules/api/axios_api';
import Constants from '../../../constants/constants';
import { MyZoneResponse } from './types';

/**
 * Retrieves user analytics for display in MyZone component
 *
 * @method getTherapistsAnalyticsById
 * @memberof MyZone
 * @returns {Promise<MyZoneResponse>} - Properties for MyZone components
 */

export const getTherapistsAnalyticsById = async (): Promise<MyZoneResponse> => {
  const url = `${Constants.BACKEND_URL}/analytics/therapist`;

  return httpGet(url, {}).then((response) => {
    if (response?.status === 200 && response?.data.success === true) {
      return response.data.result;
    }
  });
};
